import React, { useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import moment from 'moment';
import { formatTime } from '../../js/formatTime';
import { toBool } from '../../utils/Helper';
import CustomPressable from '../../components/customPressable/customPressable';
import { CustomTextInput } from '../../components/customTextInput';
import { useDispatch, useSelector } from 'react-redux';
import { getAvailbility, getEventsInfo } from '../../Redux/Actions/activitiesAction';
import { useTranslation } from 'react-i18next';
import DatePickerModal from '../../components/datePickerModal/datePickerModal';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { WAY_ACTIVITIES } from '../../config/Constant';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
import { formatDate } from '../../js/formatDate';

const WAY_UPDATE_BOOKING = "UPDATE_BOOKING";
const WAY_UPDATE_SLOT_BOOKING = "UPDATE_SLOT_BOOKING";


const ActivitiesBookingOverviewPage = (props) => {
    const { updateLoaderState, updateFetchApiError, bookingOverviewDetails, handleUpdateBooking, handleGoBack, waySessionToken, handleGetAvailability } = props;
    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const { extraConfigParam } = useSelector((state) => state.deviceConfigSlice);
    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;

    const [updateBookingFlowEnabled, setUpdateBookingFlowEnabled] = useState(false);
    const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);

    const [updatedBookingDetails, setUpdatedBookingDetails] = useState({});
    const [availabilityData, setAvailabilityData]= useState(null);
    const [availableVisibleTimeSlots, setAvailableVisibleTimeSlots] = useState();

    const session = availabilityData?.sessions?.find(s => s.date === updatedBookingDetails.date)?.sessions || [];

    

    useEffect(()=> {
        dispatch(sendAnalytics(WAY_ACTIVITIES, "SLOT BOOKING", { element: "widget", "pageName": updateBookingFlowEnabled ? WAY_UPDATE_SLOT_BOOKING : WAY_UPDATE_BOOKING, widgetSessionId: waySessionToken }));
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateBookingFlowEnabled])

    useEffect(()=> {
        if(bookingOverviewDetails?.event?.startDateTime){
            setUpdatedBookingDetails((prev)=>{ return { date: moment(bookingOverviewDetails?.event?.startDateTime).format("YYYY-MM-DD")}})
            // handleDateChange(moment(bookingOverviewDetails.event.startDateTime.split("T")[0]).format(dateFormat.toUpperCase()))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookingOverviewDetails?.event?.startDateTime])


    const getAvailabilityCallback = (status, data) => {
        updateLoaderState(false);

        if(!status){
            updateFetchApiError(true, data, () => {
                updateFetchApiError(false);
                setUpdateBookingFlowEnabled(false)
            });
            setAvailabilityData(null)
            return
        }

        if(!data?.sessions) {
            updateFetchApiError(true, "Could not find sessions.");
            return
        };

        // if(data?.sessions?.length==0) {
        //     updateFetchApiError(true, "No available sessions on selected date.");
        //     return
        // };
        const sessions = data?.sessions;

        const availableVisibleTimeSlots = [];

        for (const item of sessions) {
            const date = item?.date;
            const visibleTimeSlots = {};

            for (const session of item?.sessions || []) {
                const key = session.startTime + session.endTime;

                if (!visibleTimeSlots[key]) {
                    visibleTimeSlots[key] = [];
                }
                visibleTimeSlots[key].push(session);
            }

            availableVisibleTimeSlots.push({
                date,
                visibleTimeSlots
            });
        }

        setAvailableVisibleTimeSlots(availableVisibleTimeSlots);


        
        setAvailabilityData(data);
    }


    const fetchAvailability = () => {
        try {
            updateLoaderState(true, "Fetching availability...");

            // Need to be checked and updated
            dispatch(getAvailbility(bookingOverviewDetails.experience.id, null, getAvailabilityCallback, "experience"));
            
        } catch (err) {
          console.error("...", err);
          setAvailabilityData(null)
        }
    };
    
    const onClickUpdateMyBooking =()=>{
        if(!updatedBookingDetails.date){
            dispatch(setRenderFlashMessage(true, {type: "info", message: "Please select the date."}));
            return;
        }
        if(!updatedBookingDetails.timeSlot){
            dispatch(setRenderFlashMessage(true, {type: "info", message: "Please select the time."}));
            return;
        }
        
        const payload = {
            "sessionTime" : updatedBookingDetails?.timeSlot?.startTime,
            "sessionDate": updatedBookingDetails?.date,
            "sendConfirmationEmail": false,
            "bookingId" : bookingOverviewDetails?.id
        }

        handleUpdateBooking(payload);
    }


    const handleDateChange = (selectedDate) => {
        setIsDatePickerVisible(false)
        setUpdatedBookingDetails(prev => ({
            ...prev,
            date: moment(selectedDate).format("YYYY-MM-DD"),
            timeSlot: null // optional: date change pe reset
        }));

    }

    const handleBack = () => {
        if(updateBookingFlowEnabled){
            setUpdateBookingFlowEnabled(false);

            
            return
        }
        handleGoBack();
    }

    const handleUpdateBookingClick = () => {
        fetchAvailability()

        setUpdateBookingFlowEnabled(true)
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'activitiesBookingRootContainer'])} id='activitiesBookingRootContainer'>
        <HeaderWithBack handleCustomBackPress={handleBack} />
        <ScrollView
            automaticallyAdjustKeyboardInsets={true} 
            contentContainerStyle={getStyles(['widgetmainContainer', 'activitiesBookingMainContainer'])} 
            showsVerticalScrollIndicator={false}
            id='activitiesBookingMainContainer'
        >
                {updateBookingFlowEnabled ? <>
                    <View style={getStyles(['widgetmainContainerHeaderContainer', "activitiesBookingHeaderContainer"])} id='activitiesBookingHeaderContainer'>
                        <View style={getStyles(["widgetmainContainerHeaderTitleContainer", "activitiesBookingUpdateHeaderTitleContainer"])} id='activitiesBookingUpdateHeaderTitleContainer'>
                            <Text style={getStyles(['widgetmainContainerHeaderTitle', "activitiesBookingHeaderTitle"])} id='activitiesBookingHeaderTitle'>
                                {bookingOverviewDetails.experience.title}
                            </Text>
                        </View>
                    </View>

                    <View style={getStyles(['widgetmainContainerChildContainer', 'activitiesBookingMainContainerChildContainer'])} id='activitiesBookingMainContainerChildContainer'>

                        <View style={getStyles(['textContainer', 'activitiesBookingOverviewTextContainer'])} id='activitiesBookingOverviewTextContainer textContainer'>
                            <Text style={getStyles(['label'])} id='label'>Choose the new date:</Text>

                            <CustomPressable onPress={() => setIsDatePickerVisible(true)}>
                                <CustomTextInput
                                    value={updatedBookingDetails.date ? moment(updatedBookingDetails.date).format(dateFormat.toUpperCase()) : "Select a date" }
                                    placeholder={t('way_activity.event_list.date_placeholder')}
                                    editable={false}
                                    pointerEvents="none"
                                />
                            </CustomPressable>
                        </View>

                        {availabilityData?.sessions && ( 
                            <View style={getStyles(['activitiesCreateBookingTimeSlotsContainer'])} id='activitiesCreateBookingTimeSlotsContainer'>
                                <Text style={getStyles(['activitiesCreateBookingTimeSlots'])} >{t('way_activity.create_booking.timeslots')}</Text>

                                <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={getStyles(['activitiesCreateBookingTimeSlotsContainer'])} id="activitiesCreateBookingTimeSlotsContainer" style={{ width: '100%' }}>
                                    {session?.length > 0 ? 
                                        (
                                            session?.map((session) =>{
                                                const key = session.startTime + session.endTime;

                                                return (
                                                <CustomPressable
                                                    key={key}
                                                    style={getStyles(['activitiesCreateBookingTimeSlotsItemContainer', updatedBookingDetails.timeSlot && ( key === (updatedBookingDetails.timeSlot.startTime + updatedBookingDetails.timeSlot.endTime )) ? "activitiesCreateBookingTimeSlotsItemSelectedContainer" : "" ])}

                                                    onPress={() => setUpdatedBookingDetails(prev => { return {...prev, timeSlot:{ startTime: session.startTime , endTime: session.endTime }}} )}
                                                >
                                                    <Text style={getStyles(['activitiesCreateBookingTimeSlotsItemText', updatedBookingDetails.timeSlot && ( key === (updatedBookingDetails.timeSlot.startTime + updatedBookingDetails.timeSlot.endTime )) ? "activitiesCreateBookingTimeSlotsItemSelectedText" : ""])}>
                                                        {formatTime(session.startTime, toBool(TIME_FORMAT)) + "-" + formatTime(session.endTime,toBool(TIME_FORMAT))}
                                                    </Text>
                                                </CustomPressable>
                                            )})
                                        )
                                        :
                                        <Text style={getStyles(['noSessionAvailable'])} id='noSessionAvailable'> No session available </Text> 
                                    }
                                </ScrollView>
                            </View>)
                        }

                        
                    </View>
                </>
                : <>
                <View style={getStyles(['widgetmainContainerHeaderContainer', "activitiesBookingHeaderContainer"])} id='activitiesBookingHeaderContainer'>
                    <View style={getStyles(["widgetmainContainerHeaderTitleContainer", "activitiesBookingHeaderTitleContainer"])} id='activitiesBookingHeaderTitleContainer'>
                        <Text style={getStyles(['widgetmainContainerHeaderTitle', "activitiesBookingHeaderTitle"])} id='activitiesBookingHeaderTitle'>
                            Booking Overview
                        </Text>

                        <Text style={getStyles(['widgetmainContainerHeaderSubTitle', "activitiesBookingHeaderSubTitle"])} id='activitiesBookingHeaderSubTitle'>
                            Details of your booking
                        </Text>
                    </View>
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'activitiesBookingMainContainerChildContainer'])} id='activitiesBookingMainContainerChildContainer'>
                    <Text style={getStyles(['activitiesBookingOverviewHeadingText'])} id='activitiesBookingOverviewHeadingText'>EXPERIENCE NAME</Text>
                    <Text style={getStyles(['activitiesBookingOverviewTitle'])} id='activitiesBookingOverviewTitle'>{bookingOverviewDetails.experience.title}</Text>
        
        
                    {bookingOverviewDetails.event.startDateTime && <> 
                        <Text style={getStyles(['activitiesBookingOverviewHeadingText'])} id='activitiesBookingOverviewHeadingText'>DATE</Text>
                        <Text style={getStyles(['activitiesBookingOverviewTitle'])} id='activitiesBookingOverviewTitle'>{moment(bookingOverviewDetails.event.startDateTime.split("T")[0]).format(dateFormat.toUpperCase())}</Text> 
                        </>
                    }
        
                    {bookingOverviewDetails.event.startDateTime && <> 
                        <Text style={getStyles(['activitiesBookingOverviewHeadingText'])} id='activitiesBookingOverviewHeadingText'>TIME</Text>
                        <Text style={getStyles(['activitiesBookingOverviewTitle'])} id='activitiesBookingOverviewTitle'>{formatTime(bookingOverviewDetails.event.startDateTime.split("T")[1], toBool(TIME_FORMAT))}</Text> 
                        </>
                    }

                    {
                        bookingOverviewDetails.participants && bookingOverviewDetails.participants.length > 0 &&  <>
                            <Text style={getStyles(['activitiesBookingOverviewHeadingText', 'activitiesBookingOverviewHeadingPriceTierText'])} id='activitiesBookingOverviewHeadingText activitiesBookingOverviewHeadingPriceTierText'>PRICE TIERS</Text>
                            <View style={getStyles(['activitiesBookingOverviewParticipantsContainer'])} id='activitiesBookingOverviewParticipantsContainer'>
                                {
                                    bookingOverviewDetails.participants.map((participant, index) =>
                                        <View style={getStyles(['activitiesBookingOverviewParticipantsItemContainer'])} id='activitiesBookingOverviewParticipantsItemContainer'>
                                            <Text style={getStyles(['activitiesBookingOverviewParticipantsItemText'])} id='activitiesBookingOverviewParticipantsItemText'>{`${index+1}. ${participant.priceTierName} for ${participant.firstName} ${participant.lastName}`}</Text>
                                        </View>
                                    )
                                }
                                
                            </View>
                    </>
                    }
        
                    <Text style={getStyles(['activitiesBookingOverviewHeadingText'])} id='activitiesBookingOverviewHeadingText'>AMOUNT</Text>
                    <Text style={getStyles(['activitiesBookingOverviewTitle'])} id='activitiesBookingOverviewTitle'>{bookingOverviewDetails.currency + " " + bookingOverviewDetails.amount}</Text>

                    
                </View>
            </>
            }
        </ScrollView>

        {isDatePickerVisible &&
            <DatePickerModal
                selectedDate={updatedBookingDetails.date ? moment(updatedBookingDetails.date, "YYYY-MM-DD") : null}
                onDateChange={handleDateChange}
                onClose={() => setIsDatePickerVisible(false)}
                availableDates={availableVisibleTimeSlots?.map((a) => a.date)?.filter(Boolean)}
            />
        }

        <View style={getStyles(['activitiesBookingNextButtonContainer'])} id='activitiesBookingNextButtonContainer'>
            <CustomPressable style={getStyles(['primaryBtn'])} id="primaryBtn" 
            onPress={()=> {
                if(updateBookingFlowEnabled){
                    onClickUpdateMyBooking();
                    return;
                }
                handleUpdateBookingClick()
            }}
            >
                <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                    {updateBookingFlowEnabled ? "Update my booking" : "Continue update booking"}
                </Text>
            </CustomPressable>
        </View>
        </View>
    )
}

export default ActivitiesBookingOverviewPage
